import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { DataService } from 'src/app/services/data.service';
import { MessageService } from 'src/app/services/message.service';

@Component({
  selector: 'app-qb-vendor-form',
  templateUrl: './qb-vendor-form.component.html',
  styleUrls: ['./qb-vendor-form.component.css'],
})
export class QbVendorFormComponent {
  url: string = 'quickbooks';
  id!: string;
  syncToken!: string;
  form!: FormGroup;
  update = true;
  isLoading: boolean = false;
  //Swenson Stone Consultants
  //Malcolm Swenson, President
  resumenCards = [
    {
      label: '',
      value: 0,
      icon: 'fas fa-users',
      bgClass: 'bg-white',
      desc: 'Staff &+',
      route: '/numbers/accounting',
    },
    {
      label: '',
      value: 0,
      icon: 'fas fa-receipt',
      bgClass: 'bg-white',
      desc: 'Tax compliance',
      route: null,
    },
    {
      label: '',
      value: 0,
      icon: 'fas fa-receipt',
      bgClass: 'bg-white',
      desc: 'Invoices',
      route: '/numbers/accounting/invoices',
    },
    {
      label: '',
      value: 0,
      icon: 'fas fa-money-bill',
      bgClass: 'bg-white',
      desc: 'Bills',
      route: '/numbers/accounting/external',
    },
  ];

  constructor(
    private dataService: DataService,
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private messageService: MessageService
  ) {
    this.form = this.fb.group({
      displayName: ['', [Validators.required]],
      status: [true, [Validators.required]],
    });
  }

  ngOnInit(): void {
    this.route.params.subscribe((params: Params) => {
      this.id = params['id'];
      this.syncToken = params['syncToken'];

      if (this.id) {
        this.getData();
        this.update = false;
      }
    });
  }

  isFieldInvalid(field: string) {
    return (
      this.form.get(field)?.invalid &&
      (this.form.get(field)?.dirty || this.form.get(field)?.touched)
    );
  }

  onSubmit(): void {
    if (this.id) {
      this.updateData();
    } else {
      this.createData();
    }
  }

  getData(): void {
    this.isLoading = true;
    this.dataService
      .getData(`${this.url}/vendor/${this.id}/${this.syncToken}`)
      .subscribe((response) => {
        console.log('response get vend', response);
        this.form.patchValue({
          displayName: response?.data?.DisplayName,
          status: response?.data?.Active,
        });

        this.isLoading = false;
      });
  }

  createData(): void {
    this.isLoading = true;
    const formData = {
      ...this.form.value,
    };

    this.dataService
      .postData(`${this.url}/createVendor`, formData)
      .subscribe((response) => {
        console.log('response add cust', response);
        if (response.rst) {
          //this.messageService.add(response.msg, 'info');
          this.isLoading = false;
          this.form.reset();
          this.router.navigateByUrl('/numbers/accounting/quickbooks/vendors');
          /* this.clearValidator();
          if (this.internal) {
            this.router.navigateByUrl('/numbers/accounting/internal');
          } else {
            this.router.navigateByUrl('/numbers/accounting/external');
          } */
        } else {
          this.messageService.add(response.msg, 'secondary');
        }
      });
  }

  updateData(): void {
    this.isLoading = true;
    const formData = {
      ...this.form.value,
    };

    this.dataService
      .putData(
        `${this.url}/editVendor/${this.id}/${this.syncToken}`,
        formData
      )
      .subscribe((response) => {
        console.log('response upd ven', response);
        if (response.rst) {
          //this.messageService.add(response.msg, 'info');
          this.isLoading = false;
          this.form.reset();
          this.router.navigateByUrl('/numbers/accounting/quickbooks/vendors');

          /* this.clearValidator();
          if (this.internal) {
            this.router.navigateByUrl('/numbers/accounting/internal');
          } else {
            this.router.navigateByUrl('/numbers/accounting/external');
          } */
        } else {
          this.messageService.add(response.msg, 'secondary');
        }
      });
  }

  enableUpdate() {
    this.update = !this.update;
  }
}
